import React from 'react';
import { Col, Row, Container } from 'reactstrap';
import logos from './logos/Logos';
import { useTranslation, Trans } from 'react-i18next';
import { Link } from 'react-router-dom';

const About: React.FC = () => {
    const { t } = useTranslation(['coomon']);

    return <div className="about">
        <div className="hero">
            <div className="bg">
                <div className="text">
                    <h1>{t('about.title', { ns: 'common' })}</h1>
                </div>
            </div>
        </div>

        <div className="content bg">
            <Row className="content_box">
                <Col sm="4" className="text right">
                    <h3>{t('about.simplicity.title', { ns: 'common' })}</h3>
                    <p>{t('about.simplicity.text1', { ns: 'common' })}</p>
                    <p>{t('about.simplicity.text2', { ns: 'common' })}</p>
                </Col>
                <Col sm="8" className="image">
                    <img src="./FlowSync-create-module-1500.png" alt="" />
                </Col>
            </Row>

            <Row className="content_box reverse">
                <Col sm="8" className="image">
                    <img src="./FlowSync-user.png" alt="" />
                </Col>
                <Col sm="4" className="text left">
                    <h3>{t('about.transparency.title', { ns: 'common' })}</h3>
                    <p>{t('about.transparency.text1', { ns: 'common' })}</p>
                    <p>{t('about.transparency.text2', { ns: 'common' })}</p>
                </Col>
            </Row>

            <Row className="content_box">
                <Col sm="4" className="text right">
                    <h3>{t('about.speed.title', { ns: 'common' })}</h3>
                    <p>{t('about.speed.text1', { ns: 'common' })}</p>
                    <p>{t('about.speed.text2', { ns: 'common' })}</p>
                </Col>
                <Col sm="8" className="image">
                    <img src="./FlowSync-oneroster.png" alt="" />
                </Col>
            </Row>

            <Row className="content_box reverse">
                <Col sm="8" className="image">
                    <img className="image-bg" src="./flowsync_flow.png" alt="" />
                </Col>
                <Col sm="4" className="text left">
                    <h3>{t('about.future.title', { ns: 'common' })}</h3>
                    <p><Trans i18nKey='about.future.text1' ns='common' components={{
                        lnkSS12000: <a href="https://www.sis.se/produkter/informationsteknik-kontorsutrustning/ittillampningar/ittillampningar-inom-utbildning/ss-120002020/" target="_blank" rel="noopener noreferrer">placeholder</a>,
                        lnkOneRoster: <a href="https://www.imsglobal.org/oneroster-v11-final-specification" target="_blank" rel="noopener noreferrer">placeholder</a>,
                        lnkSDS: <a href="https://sds.microsoft.com/" target="_blank" rel="noopener noreferrer">placeholder</a>,
                        lnkClassroom: <a href="https://developers.google.com/classroom" target="_blank" rel="noopener noreferrer">placeholder</a>,
                    }} /></p>
                    <p>{t('about.future.text2', { ns: 'common' })}</p>
                </Col>
            </Row>
        </div>

        <Row className="content_box_vertical logotypes">
            <Container>
                <div className="text">
                    <h3>{t('about.puzzle.title', { ns: 'common' })}</h3>
                    <p>{t('about.puzzle.text1', { ns: 'common' })}</p>
                    <p>{t('about.puzzle.text2', { ns: 'common' })}</p>
                </div>
                <div className="logos">
                    {logos.map((logo, i) => {
                        return (
                            <div key={i}>
                                <img className="logo" src={logo.img} alt={logo.name} />
                            </div>
                        )
                    }
                    )}
                </div>
            </Container>
        </Row>

        <Row className="contact">
            <Container>
                <div className="text">
                    <h3>{t('about.contact.title', { ns: 'common' })}</h3>
                    <p>{t('about.contact.text1', { ns: 'common' })}</p>
                    <div className="btn-box">
                        <a href="https://www.eventful.se/om-oss/" target="_blank" rel="noopener noreferrer" className="btn">{t('about.contact.contactUs', { ns: 'common' })}</a>
                    </div>
                </div>
            </Container>
        </Row>
    </div>
}

export default About;
